import { render, staticRenderFns } from "./Imovel.vue?vue&type=template&id=63d693ed&"
import script from "./Imovel.vue?vue&type=script&lang=js&"
export * from "./Imovel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports